import StudentPng from '../assets/student.png';
import PeerPng from '../assets/peer.png';
import EdTechPng from '../assets/edtech.png';
import BioTechnologyPng from '../assets/biotechnology.png';
import PersonalizedPng from '../assets/personalized.png';

function InfiniteScrollSectionOne() {
  const infiniteScrollContent = [
    {
      imgUrl: StudentPng,
      key: 1,
    },

    {
      imgUrl: PeerPng,
      key: 2,
    },

    {
      imgUrl: EdTechPng,
      key: 3,
    },

    {
      imgUrl: BioTechnologyPng,
      key: 4,
    },

    {
      imgUrl: PersonalizedPng,
      key: 5,
    },
  ];

  const width = '250px';
  const quantity = infiniteScrollContent.length;

  return (
    <div
      className="infinite-slider h-12 overflow-hidden w-full"
      style={{
        '--width': width,
        '--quantity': quantity,
      }}
    >
      <div className="list w-full h-full flex gap-2 md:gap-4 items-center relative">
        {infiniteScrollContent.map((item) => {
          const { imgUrl, key } = item;

          return (
            <div
              className="flex w-full items-center justify-center h-10 item left-full animate-autoRun"
              key={key}
              style={{
                '--position': key,
                animationDelay:
                  'calc((10s / var(--quantity)) * (var(--position) - 1) - 10s)',
              }}
            >
              <img src={imgUrl} alt="" />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default InfiniteScrollSectionOne;
